import { css, DialogTitle, styled } from '@mui/material';
import IconButton from 'ui/components/IconButton/IconButton';

export const DialogTitleStyled = styled(DialogTitle)`
  ${({ theme }) => css`
    display: flex;
    margin: ${theme.spacing(0)};
    padding: ${theme.spacing(2)};
  `}
`;

export const IconButtonStyled = styled(IconButton)`
  margin-left: auto;
`;
